home.popularLeaguesModule = {
    // Funkcia na renderovanie stranky popularLeagues
    popularLeaguesRender: function(data) {
        try {
            if (data && !data.ErrorType) {
                // Render
                directives.popularSportsbookDirective.sportsBookPopular.render("sportsBook", data);
                // Zobrazenie ponuky
                $("#sportsBook, #events").show();
                $("#home, #empty").hide();
                home.popularLeaguesModule.popularLeaguesSelect();
                return true;
            } else {
                main.setPage(1);
                modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.setPage(1);
            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
            return false;
        }
    },

    // Funkcia na oznacenie vybranej popularnej ligy
    popularLeaguesSelect: function() {
        try {
            // Zobrazi/Skryje v sporbooku posuvne tlacitka hore/dole,
            shared.scrollModule.scrollButtons("offer");

            // Oznacenie stromu
            // TODO - po update EO-browser upravit handlovanie pomocou atributu name
            $("#sportsBook details").prop("open", false);
            $("#sportsBook #LC" + offer.leagueCupID).prop("open", true);
        
            // Popisky - prida nazov popularnej ligy so sipkou, ikonu sportu pre popularne ligy
            $("#tableTop .table-title").html('<span class="table-title-sport">' + $("#sportsBook #LC" + offer.leagueCupID + " .league-popular-wrapper").text().replace("-", "<span class='icon-arrow-right'></span>") + '</span>');
            $("#tableTop .table-icon").removeClass().addClass("table-icon sport-icon-" + offer.sportID + " sport-color-" + offer.sportID);
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na otvorenia popularnej ligy
    popularLeagueEvents: function(sportID, regionID, leagueCupID) {
        if (offer.page != "popularLeagues") {
            $("#home").addClass("lock-btn");
            setTimeout(function () {
                $("#home").removeAttr("class");
                if (profile.QuickBetsAllowed && profile.QuickBets.HomePage) {
                    $("#home").addClass("has-quickbet");
                }
                if (!profile.VictoryMachine && !stored.popularLeaguesHandler) {
                    shared.scrollModule.scrollOnTapAndHold(null, "content-offer");
                    stored.popularLeaguesHandler = true;
                }
            }, 500);

            // Prejde na stranku popularLeagues
            main.setPage(9);
        }
        offer.sportID = offer.SeSpID = sportID;
        offer.regionID = regionID;
        offer.leagueCupID = leagueCupID;
        $("#sportsBook, #events").addClass("ui-disabled");
        service.loadPure('sportsBookEvents', "LC" + leagueCupID);
        home.popularLeaguesModule.popularLeaguesSelect();
        // GA4 - nastavenie zmenenenej cesty screenu (TOP LIGY) do title pre trackovanie do GA4
        var screenPath = $("#sportsBook #LC" + leagueCupID + " .flat-sport-name").text();
        communication.dataTrackModule.setScreenPath(0, screenPath);
        return false;
    }
};
